module.exports = __webpack_public_path__ + "img/mock.ad629829.jpg";